import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { raiseToast } from '../toast/toast';
import { searchPermActions } from '../../../api/permAction';


export const fetchPermActions = createAsyncThunk('user/getVendorPaymentsCheques', async (params, { dispatch }) => {
    const response = await searchPermActions(params)
    console.log("fetchPermActions", response)
    if(response.failure){
        dispatch(raiseToast({severity:'error', detail: response.data.error}))
        throw Error()
    }
    return response
})

export const permissionsSlice = createSlice({
    name : "permissions",
    initialState : {
        loading: false ,
        permissionsData: [],
        searchParams: {
            dataType: "permActionData",
            permissionsPageFlag: true,
            //paginator: false,
            statusId: 1,
            searchBy: "all",
            searchText: ""
        },
        searchOptions: []
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updatePermissionsData: (state, action) => {
            state.permissionsData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchPermActions.fulfilled, (state, action) => {
                state.loading = false 
                state.permissionsData = action.payload.data
            }
        )
        .addCase(
            fetchPermActions.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchPermActions.rejected, (state, action) => {
                state.loading = false
                state.permissionsData = []
            }
        )
    }
})

export const { updateSearchParams, updateSearchOptions, updatePermissionsData } = permissionsSlice.actions

export default permissionsSlice.reducer